import { render } from "./CacheUsageOverview.vue?vue&type=template&id=f84f1348&scoped=true"
import script from "./CacheUsageOverview.vue?vue&type=script&lang=js"
export * from "./CacheUsageOverview.vue?vue&type=script&lang=js"

import "./CacheUsageOverview.vue?vue&type=style&index=0&id=f84f1348&lang=scss&scoped=true"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84f1348"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QTd,QBtn});
